import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'CreditCard48',
  props: {
    size: {
      type: [String, Number],
      default: '48',
    },
    fill: {
      type: String,
      default: '#757575',
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M40 8H8C5.78 8 4.02 9.78 4.02 12L4 36C4 38.22 5.78 40 8 40H40C42.22 40 44 38.22 44 36V12C44 9.78 42.22 8 40 8ZM42 36C42 37.1046 41.1046 38 40 38H8C6.89543 38 6 37.1046 6 36V24C6 22.8954 6.89543 22 8 22H40C41.1046 22 42 22.8954 42 24V36ZM40 16C41.1046 16 42 15.1046 42 14V12C42 10.8954 41.1046 10 40 10H8C6.89543 10 6 10.8954 6 12V14C6 15.1046 6.89543 16 8 16H40Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})